/**
 * Global function called by Android WebView to pass FCM token
 * Called automatically after page loads in WebView
 */
window.onNativeTokenReceived = function (token) {
    console.log('📱 FCM Token received from Android:', token.substring(0, 20) + '...');

    // Store in localStorage for session persistence
    localStorage.setItem('fcm_token', token);

    // Dispatch custom event for app-wide reactivity
    window.dispatchEvent(new CustomEvent('fcm-token-received', {
        detail: { token }
    }));

    console.log('✅ FCM token stored in localStorage');
};

// Log when bridge is ready
console.log('🔗 FCM Bridge initialized - ready to receive tokens');
